import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M8 17h8v1H8zM8 2h8v1H8z",
  opacity: ".3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7 22h2v2H7zm4 0h2v2h-2zm4 0h2v2h-2zM16 .01L8 0C6.9 0 6 .9 6 2v16c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V2c0-1.1-.9-1.99-2-1.99zM16 18H8v-1h8v1zm0-3H8V5h8v10zm0-12H8V2h8v1z"
})), 'SettingsCellTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/SettingsCellTwoTone.js
// module id = 6023
// module chunks = 2